import {Pipe, PipeTransform} from '@angular/core';
import {clientRoles} from '../../core/constants/client-roles.config';
import {Article} from '../../core/models/articles/articles.model';
import {User} from '../../core/models/users/users.model';

@Pipe({
  name: 'canEdit',
  standalone: true,
})
export class CanEditPipe implements PipeTransform {
  transform(user: User, article: Article, userRoles: string[]): boolean {
    return userRoles.includes(clientRoles.IS_ADMIN)
      || userRoles.includes(clientRoles.IS_SUBADMIN) && article.institution === user?.institution
      || userRoles.includes(clientRoles.IS_AUTHOR) && article.institution === user?.institution;
  }
}
